
import { defineComponent } from "@vue/runtime-core";
import Btn from "../Btn.vue";
import Card from "../Card.vue";

export default defineComponent({
	name: "EventEditorPreviewSkeleton",
	components: { Btn, Card },
});
